class TextareaCount extends HTMLElement {
  constructor() {
    super();

    // Keyup event listener
    this.addEventListener('keyup', (event) => {
      // Sending the new value to the update method
      this.updateCharacterCount(event.target.value.length);
    });
  }

  updateCharacterCount(newAmount) {
    const current = this.querySelector('.textareaCurrentCount');

    current.innerText = newAmount;
  }
}

// Defining the element
customElements.define('textarea-count', TextareaCount);
